var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"product-media-input"},[_c(_setup.ImageUpload,{attrs:{"beforeUpload":_vm.beforeUpload,"onUpload":_setup.onUpload,"value":_setup.fileUrl,"width":_vm.width,"height":_vm.height,"fit":_vm.fit,"clearable":_vm.clearable},on:{"success":_setup.onSuccess,"clear":_setup.onClear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }